import { Select, Spin } from "antd";
import { useEffect } from "react";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { useSelector } from "react-redux";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/products/get-products-actions";
import { PageSetting } from "../../..";
import { LoadingOutlined } from "@ant-design/icons";

interface Props {
  onChange: (value: string) => void;
  size?: SizeType;
  onClear: () => void;
  mode?: any;
  defaultValue?: any;
  style?: any;
}

const dispatch = store.dispatch;

const SelectProducts = (props: Props) => {
  const productsState = useSelector((state: any) => state.products);
  const userState = useSelector((state: any) => state.user);
  const customLoadingIndicator = (
    <Spin
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 20,
            color: "#1890ff", // Puedes cambiar el color aquí
          }}
          spin
        />
      }
      size="small"
    />
  );

  useEffect(() => {
    if (userState.user.me.role.name === "Admin") {
      dispatch(
        find(PageSetting.page, -1, {
          filter: {},
        })
      );
    } else {
      dispatch(
        find(PageSetting.page, -1, {
          filter: {},
        })
      );
    }
  }, []);

  // Función para filtrar las opciones basadas en la búsqueda
  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => {
    return option?.label.toLowerCase().includes(input.toLowerCase()) ?? false;
  };

  return (
    <div style={{ width: "100%" }}>
      <Select
        {...props}
        loading={productsState?.isLoading}
        allowClear
        labelInValue={props.mode === "multiple" ? true : false}
        showSearch
        filterOption={filterOption}
        optionFilterProp="label"
        size={props.size}
        defaultValue={props.defaultValue}
        style={props.style}
        onChange={(value: any) => {
          props.onChange(value);
        }}
        options={
          productsState?.list?.map((e: any) => ({
            label: e.name,
            value: e.id,
          })) || []
        }
      />
    </div>
  );
};

export default SelectProducts;
